import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { motion } from 'motion/react';

const transition = {
    ease: 'easeOut',
    duration: 0.15
};
const variants = {
    enter: {
        y: 0,
        opacity: 1,
        transition
    },
    exit: {
        y: -5,
        opacity: 0,
        transition
    }
};
const FlyoutMenu = (_param)=> {
    var { className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className"
    ]);
    return React.createElement(motion.ul, swcHelpers.extends({}, rest, {
        role: "menu",
        className: classnames(`flyout-menu`, className),
        variants: variants,
        initial: "exit",
        animate: "enter",
        exit: "exit"
    }));
};

export { FlyoutMenu as default };
//# sourceMappingURL=FlyoutMenu.js.map
